export default __webpack_public_path__ + "static/media/gt6.ab0d13b7.png";